<template>
  <div class="page-container">
    <!-- 头部 -->
    <Header />

    <!-- 主要内容 -->
    <div class="about-page">
      <!-- 页面头部 -->
      <div class="page-header animate-on-scroll">
        <div class="header-background"></div>
        <div class="gradient-overlay"></div>
        <div class="container">
          <h1>关于美音</h1>
          <p>优质服务先行者</p>
        </div>
      </div>

      <!-- 公司简介 -->
      <section id="company-intro" class="company-intro">
        <div class="container">
          <h2 class="animate-on-scroll">公司介绍</h2>
          <div class="content">
            <div class="text animate-on-scroll slide-left">
              <p>湖南美音网络技术有限公司成立于2008年，注册资金1001万元，致力于软件和信息技术服务业的深耕，以"优质运维先行者"为公司战略发展方向，围绕运维服务产业不断革新管理模式、服务标准与工具平台，提供信息技术服务行业的最佳解决方案。</p>
              <p>公司多年来坚持着"诚信、创新、专业、服务"的核心价值观，从服务最佳实践出发，在行业内获得许多专业认证。2016年获得电子政务理事会颁发的全国"2015年电子政务优秀供应商"称号。</p>
            </div>
            <div class="image animate-on-scroll slide-right">
              <img :src="require('@/assets/images/gs.jpg')" alt="公司照片">
            </div>
          </div>
        </div>
      </section>

      <!-- 企业文化 -->
      <section id="company-culture" class="culture-section">
        <div class="container">
          <h2 class="animate-on-scroll">企业文化</h2>
          <div class="culture-content">
            <!-- 企业价值观 -->
            <div class="culture-block values-block animate-on-scroll">
              <div class="block-header">
                <div class="title-icon">
                  <el-icon><Star /></el-icon>
                </div>
                <h3>企业价值观</h3>
              </div>
              <div class="values-grid">
                <div class="value-item">
                  <div class="icon">
                    <el-icon><Medal /></el-icon>
                  </div>
                  <div class="content">
                    <h4>诚信</h4>
                    <p>做一个值得信赖的企业</p>
                  </div>
                </div>
                <div class="value-item">
                  <div class="icon">
                    <el-icon><Cpu /></el-icon>
                  </div>
                  <div class="content">
                    <h4>专业</h4>
                    <p>做一个有专业价值的企业</p>
                  </div>
                </div>
                <div class="value-item">
                  <div class="icon">
                    <el-icon><MagicStick /></el-icon>
                  </div>
                  <div class="content">
                    <h4>创新</h4>
                    <p>做一个有创新能力的企业</p>
                  </div>
                </div>
                <div class="value-item">
                  <div class="icon">
                    <el-icon><Service /></el-icon>
                  </div>
                  <div class="content">
                    <h4>服务</h4>
                    <p>做一个有服务能力的企业</p>
                  </div>
                </div>
              </div>
            </div>

            <!-- 企业使命 -->
            <div class="culture-block mission-block animate-on-scroll">
              <div class="block-header">
                <div class="title-icon">
                  <el-icon><Aim /></el-icon>
                </div>
                <h3>企业使命</h3>
              </div>
              <div class="mission-content">
                <div class="mission-slogan">
                  <p>引领服务管理，创新服务升级</p>
                </div>
                <div class="mission-grid">
                  <div class="mission-item">
                    <div class="icon">
                      <el-icon><Connection /></el-icon>
                    </div>
                    <div class="content">
                      <h5>恪守商业规则</h5>
                      <p>与合作伙伴一同构建良好的商业生态</p>
                    </div>
                  </div>
                  <div class="mission-item">
                    <div class="icon">
                      <el-icon><Refresh /></el-icon>
                    </div>
                    <div class="content">
                      <h5>创新服务模式</h5>
                      <p>提高服务效率，提升服务品质，创造客户价值</p>
                    </div>
                  </div>
                  <div class="mission-item">
                    <div class="icon">
                      <el-icon><Flag /></el-icon>
                    </div>
                    <div class="content">
                      <h5>打造服务湘军</h5>
                      <p>完善服务体系，塑造服务品牌，树立行业标杆</p>
                    </div>
                  </div>
                  <div class="mission-item">
                    <div class="icon">
                      <el-icon><User /></el-icon>
                    </div>
                    <div class="content">
                      <h5>承担社会责任</h5>
                      <p>以实际行动回报客户、回报员工、回报社会</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 合作伙伴 -->
      <section id="company-partners" class="partners">
        <div class="container">
          <h2>合作伙伴</h2>
          <div class="partners-grid">
            <div 
              class="partner-item" 
              v-for="partner in partners" 
              :key="partner.id"
            >
              <div class="partner-content">
                <div class="img-wrapper">
                  <img :src="baseUrl + '/media' + partner.cover" :alt="partner.title">
                </div>
                <div class="partner-title">
                  <span>{{ partner.title }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 联系我们 -->
      <section id="company-contact" class="contact">
        <div class="container">
          <h2>联系我们</h2>
          <div class="contact-content">
            <div class="contact-map">
              <BMap />
            </div>
            <div class="contact-info">
              <div class="info-list">
                <div class="info-item">
                  <el-icon><Location /></el-icon>
                  <div class="text">
                    <h3>公司地址</h3>
                    <p>长沙市开福区芙蓉中路一段442号新湖南大厦产业楼</p>
                  </div>
                </div>
           
                <div class="info-item">
                  <el-icon><Phone /></el-icon>
                  <div class="text">
                    <h3>联系电话</h3>
                    <p>0731-8882-6586</p>
                  </div>
                </div>
                <div class="info-item">
                  <el-icon><Phone /></el-icon>
                  <div class="text">
                    <h3>服务热线</h3>
                    <p>400-9933-299</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <!-- 底部 -->
    <Footer />
  </div>
</template>

<script setup >
import { ref, onMounted, watch, computed, nextTick } from 'vue'
import { useRoute } from 'vue-router'
import { ArrowRight, Location, Phone, Message, Medal, Cpu, MagicStick, Service, Connection, Refresh, Flag, User, Star, Aim } from '@element-plus/icons-vue'
import BMap from '@/components/BMap.vue'
import Header from '@/layout/header/index.vue'
import Footer from '@/layout/footer/index.vue'
import axios from 'axios'
import { getBaseApiUrl } from '@/utils/api-config'

const route = useRoute()
const baseUrl = getBaseApiUrl()

// 处理锚点跳转
const handleAnchorScroll = () => {
  if (route.hash) {
    const elementId = route.hash.slice(1)
    const element = document.getElementById(elementId)
    if (element) {
      const headerHeight = 80 // header 的高度
      const elementTop = element.offsetTop - headerHeight
      window.scrollTo({
        top: elementTop,
        behavior: 'smooth'
      })
    }
  }
}

// 监听路由变化
watch(() => route.hash, () => {
  setTimeout(handleAnchorScroll, 50)
})

// 合作伙伴数据
const partners = ref([])

// 获取合作伙伴数据
const getPartners = async () => {
  try {
    const response = await axios.get(`${baseUrl}/api/article/article/`, {
      params: {
        page: 1,
        limit: 100,
        column: 21,
        status: 'published'
      }
    })
    if (response.data.code === 2000) {
      partners.value = response.data.data.data
      console.log('合作伙伴数据:', partners.value)
    }
  } catch (error) {
    console.error('获取合作伙伴数据失败:', error)
  }
}

// 复制合作伙伴数据用于无缝轮播
const displayPartners = computed(() => {
  // 如果数据少于3条，直接返回原始数据
  if (partners.value.length < 3) {
    return partners.value
  }
  // 如果数据大于等于3条，则复制一份用于无缝轮播
  return [...partners.value, ...partners.value]
})

// 轮播动画控制
const carouselPosition = ref(0)
const carouselStyle = computed(() => {
  // 如果数据少于3条，不进行轮播
  if (partners.value.length < 3) {
    return {
      transform: 'none',
      transition: 'none'
    }
  }
  return {
    transform: `translateX(${-carouselPosition.value}px)`,
    transition: 'transform 30s linear infinite'
  }
})

// 启动轮播
const startCarousel = () => {
  // 如果数据少于3条，不启动轮播
  if (partners.value.length < 3) {
    return
  }
  const track = document.querySelector('.carousel-track')
  if (track) {
    const trackWidth = track.offsetWidth / 2
    carouselPosition.value = trackWidth
  }
}

onMounted(() => {
  getPartners()
  handleAnchorScroll()
  // 等待数据加载和DOM更新后启动轮播
  nextTick(() => {
    startCarousel()
  })

  // 添加滚动监听
  const observerCallback = (entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('show');
      }
    });
  };

  const observer = new IntersectionObserver(observerCallback, {
    threshold: 0.1
  });

  // 观察所有需要动画的元素
  document.querySelectorAll('.animate-on-scroll').forEach(el => {
    observer.observe(el);
  });
})

// 新闻数据
const newsData = [
  {
    id: 1,
    title: '美音科技荣获2023年度优秀服务商称号',
    date: '2023-12-20',
    summary: '在2023年度评选中，湖南美音凭借优质的服务能力和创新的技术方案...',
    image: require('@/assets/images/15.png')
  },
  {
    id: 2,
    title: '美音科技成功举办2023技术创新大会',
    date: '2023-11-15',
    summary: '大会聚焦IT运维服务创新，展示了多项自主研发的技术成果...',
    image: require('@/assets/images/15.png')
  },
  {
    id: 3,
    title: '美音科技参与2023数字化转型峰会',
    date: '2023-10-25',
    summary: '公司受邀参加2023数字化转型峰会，分享IT运维服务创新经验...',
    image: require('@/assets/images/15.png')
  },
  {
    id: 4,
    title: '美音科技推出新一代运维管理平台',
    date: '2023-09-30',
    summary: '新一代运维管理平台正式发布，助力企业提升运维效率...',
    image: require('@/assets/images/15.png')
  }
]
</script>

<style lang="scss" scoped>
.page-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;

  .about-page {
    flex: 1;

    .page-header {
      position: relative;
      padding: 120px 0 60px;
      text-align: center;
      color: #fff;
      overflow: hidden;

      .header-background {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-image: url('@/assets/images/DSC_4672.jpg');
        background-size: cover;
        background-position: center;
        background-attachment: fixed;
        filter: brightness(1);
        z-index: 1;
      }

      .gradient-overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(
          to bottom,
          rgba(11, 27, 72, 0.5) 0%,
          rgba(23, 43, 77, 0.4) 100%
        );
        z-index: 2;
      }

      .container {
        position: relative;
        z-index: 3;
      }

      h1 {
        font-size: 36px;
        font-weight: 500;
        margin-bottom: 16px;
        position: relative;
        display: inline-block;
        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
        
        &::after {
          content: '';
          position: absolute;
          bottom: -10px;
          left: 50%;
          transform: translateX(-50%);
          width: 60px;
          height: 3px;
          background: rgba(255, 255, 255, 0.6);
          border-radius: 2px;
        }
      }

      p {
        font-size: 18px;
        margin-top: 20px;
        opacity: 0.9;
        text-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
        letter-spacing: 0.5px;
      }

      @media (max-width: 768px) {
        padding: 100px 0 40px;

        h1 {
          font-size: 28px;
        }

        p {
          font-size: 16px;
        }
      }
    }

    .container {
      max-width: 1200px;
      margin: 0 auto;
      padding: 0 20px;
    }

    section {
      padding: 80px 0;
      position: relative;
      
      &::before {
        content: '';
        display: block;
        height: 80px;
        margin: -80px 0 0;
        visibility: hidden;
        pointer-events: none;
      }

      h2 {
        font-size: 32px;
        text-align: center;
        margin-bottom: 40px;
        position: relative;
        
        &::after {
          content: '';
          position: absolute;
          bottom: -10px;
          left: 50%;
          transform: translateX(-50%);
          width: 60px;
          height: 3px;
          background: #2b5dff;
        }
      }
    }

    .company-intro {
      background: #fff;

      .content {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 60px;
        align-items: center;

        .text {
          p {
            margin-bottom: 20px;
            line-height: 1.8;
            color: #666;
          }
        }

        .image {
          img {
            width: 100%;
            border-radius: 8px;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
          }
        }
      }
    }

    .culture-section {
      background: #f8f9fa;
      padding: 80px 0;

      h2 {
        font-size: 32px;
        text-align: center;
        margin-bottom: 60px;
        position: relative;
        color: #333;
        
        &::after {
          content: '';
          position: absolute;
          bottom: -15px;
          left: 50%;
          transform: translateX(-50%);
          width: 60px;
          height: 3px;
          background: #2b5dff;
          border-radius: 2px;
        }
      }

      .culture-content {
        display: grid;
        grid-template-columns: 1fr;
        gap: 40px;
      }

      .culture-block {
        background: #fff;
        border-radius: 16px;
        padding: 40px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);

        .block-header {
          display: flex;
          align-items: center;
          gap: 15px;
          margin-bottom: 40px;
          padding-bottom: 20px;
          border-bottom: 1px solid #eee;

          .title-icon {
            width: 40px;
            height: 40px;
            background: #2b5dff;
            border-radius: 10px;
            display: flex;
            align-items: center;
            justify-content: center;

            .el-icon {
              font-size: 24px;
              color: #fff;
            }
          }

          h3 {
            font-size: 24px;
            color: #333;
            margin: 0;
          }
        }
      }

      // 企业价值观样式
      .values-block {
        .values-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 30px;

          .value-item {
            background: #f8f9fc;
            padding: 30px;
            border-radius: 12px;
            transition: all 0.3s ease;
            text-align: center;

            &:hover {
              transform: translateY(-5px);
              box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);

              .icon {
                background: #2b5dff;
                
                .el-icon {
                  color: #fff;
                }
              }
            }

            .icon {
              width: 60px;
              height: 60px;
              background: rgba(43, 93, 255, 0.1);
              border-radius: 12px;
              display: flex;
              align-items: center;
              justify-content: center;
              margin: 0 auto 20px;
              transition: all 0.3s ease;

              .el-icon {
                font-size: 28px;
                color: #2b5dff;
                transition: all 0.3s ease;
              }
            }

            .content {
              h4 {
                font-size: 20px;
                color: #333;
                margin-bottom: 10px;
              }

              p {
                color: #666;
                font-size: 15px;
                line-height: 1.6;
                margin: 0;
              }
            }
          }
        }
      }

      // 企业使命样式
      .mission-block {
        .mission-content {
          .mission-slogan {
            text-align: center;
            margin-bottom: 40px;
            
            p {
              font-size: 24px;
              color: #2b5dff;
              font-weight: 500;
              display: inline-block;
              padding: 15px 40px;
              background: #f8f9fc;
              border-radius: 30px;
              box-shadow: inset 0 2px 6px rgba(43, 93, 255, 0.1);
            }
          }

          .mission-grid {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 30px;

            .mission-item {
              background: #f8f9fc;
              padding: 30px;
              border-radius: 12px;
              display: flex;
              align-items: center;
              gap: 20px;
              transition: all 0.3s ease;

              &:hover {
                transform: translateY(-5px);
                box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);

                .icon {
                  background: #2b5dff;
                  
                  .el-icon {
                    color: #fff;
                  }
                }
              }

              .icon {
                width: 50px;
                height: 50px;
                background: rgba(43, 93, 255, 0.1);
                border-radius: 10px;
                display: flex;
                align-items: center;
                justify-content: center;
                transition: all 0.3s ease;

                .el-icon {
                  font-size: 24px;
                  color: #2b5dff;
                  transition: all 0.3s ease;
                }
              }

              .content {
                flex: 1;

                h5 {
                  font-size: 18px;
                  color: #333;
                  margin-bottom: 8px;
                }

                p {
                  color: #666;
                  font-size: 14px;
                  line-height: 1.6;
                  margin: 0;
                }
              }
            }
          }
        }
      }
    }

    .partners {
      background: #fff;
      padding: 80px 0;

      h2 {
        font-size: 36px;
        text-align: center;
        margin-bottom: 50px;
        position: relative;
        color: #333;
        
        &::after {
          content: '';
          position: absolute;
          bottom: -15px;
          left: 50%;
          transform: translateX(-50%);
          width: 80px;
          height: 4px;
          background: linear-gradient(90deg, #2b5dff 0%, #1a45e0 100%);
          border-radius: 2px;
        }
      }

      .partners-grid {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 30px;
        padding: 20px;
        max-width: 1200px;
        margin: 0 auto;
      }

      .partner-item {
        .partner-content {
          background: #fff;
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
          transition: all 0.3s ease;
          height: 200px;
          display: flex;
          flex-direction: column;

          &:hover {
            transform: translateY(-5px);
            box-shadow: 0 8px 30px rgba(43, 93, 255, 0.1);

            .img-wrapper img {
              transform: scale(1.05);
            }

            .partner-title {
              background: #2b5dff;
              
              span {
                color: #fff;
              }
            }
          }

          .img-wrapper {
            flex: 1;
            padding: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #fff;
            overflow: hidden;

            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
              transition: transform 0.3s ease;
            }
          }

          .partner-title {
            padding: 8px;
            background: #f6f8ff;
            transition: all 0.3s ease;
            min-height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;

            span {
              display: block;
              text-align: center;
              font-size: 14px;
              font-weight: 500;
              color: #2b5dff;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              transition: color 0.3s ease;
            }
          }
        }
      }

      @media (max-width: 992px) {
        .partners-grid {
          grid-template-columns: repeat(3, 1fr);
          gap: 25px;
        }
      }

      @media (max-width: 768px) {
        .partners-grid {
          grid-template-columns: repeat(2, 1fr);
          gap: 20px;
          padding: 15px;
        }

        .partner-item {
          .partner-content {
            height: 180px;

            .partner-title span {
              font-size: 14px;
            }
          }
        }
      }

      @media (max-width: 480px) {
        .partners-grid {
          grid-template-columns: repeat(1, 1fr);
          gap: 15px;
          padding: 10px;
        }

        .partner-item {
          .partner-content {
            height: 160px;

            .partner-title span {
              font-size: 13px;
            }
          }
        }
      }
    }

    .contact {
      padding: 80px 0;
      background: #f8f9fc;

      h2 {
        text-align: center;
        margin-bottom: 40px;
        font-size: 32px;
        position: relative;
        
        &::after {
          content: '';
          position: absolute;
          bottom: -10px;
          left: 50%;
          transform: translateX(-50%);
          width: 60px;
          height: 3px;
          background: #2b5dff;
        }
      }

      .contact-content {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 40px;
        align-items: start;
        max-width: 1200px;
        margin: 0 auto;
      }

      .contact-map {
        height: 100%;
        
        .bmap-container {
          height: 100%;
          min-height: 400px;
        }
      }

      .contact-info {
        height: 100%;
        display: flex;
        align-items: center;

        .info-list {
          width: 100%;
        }

        .info-item {
          display: flex;
          align-items: flex-start;
          gap: 15px;
          margin-bottom: 20px;
          padding: 25px;
          background: #fff;
          border-radius: 8px;
          box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
          transition: transform 0.3s;

          &:last-child {
            margin-bottom: 0;
          }

          &:hover {
            transform: translateY(-2px);
          }

          .el-icon {
            font-size: 24px;
            color: #2b5dff;
          }

          .text {
            flex: 1;

            h3 {
              font-size: 18px;
              margin-bottom: 8px;
              color: #333;
            }

            p {
              color: #666;
              line-height: 1.5;
              margin: 0;
            }
          }
        }
      }
    }

    @media (max-width: 992px) {
      .contact-content {
        grid-template-columns: 1fr;
        gap: 30px;
      }

      .contact-map {
        .bmap-container {
          min-height: 300px;
        }
      }
    }

    @media (max-width: 768px) {
      .page-header {
        padding: 100px 0 40px;
      }

      .company-intro {
        .content {
          grid-template-columns: 1fr;
          gap: 30px;
        }
      }

      .culture-section {
        padding: 60px 0;

        .section-title {
          margin-bottom: 40px;

          h2 {
            font-size: 28px;
          }
        }

        h3 {
          font-size: 24px;
          margin-bottom: 30px;
        }

        .mission-grid {
          grid-template-columns: 1fr !important;
        }

        .mission-item {
          padding: 30px !important;
        }
      }

      .partners {
        .partner-item {
          flex: 0 0 240px !important;

          .partner-content {
            height: 180px;

            .partner-title span {
              font-size: 14px;
            }
          }
        }
      }

      .news {
        .news-grid {
          grid-template-columns: 1fr;
        }
      }

      .contact {
        .contact-content {
          grid-template-columns: 1fr;
          gap: 30px;
        }
      }
    }

    @media (max-width: 480px) {
      .company-intro {
        .content {
          grid-template-columns: 1fr;
          gap: 30px;
        }
      }

      .partners {
        .partner-item {
          flex: 0 0 200px !important;

          .partner-content {
            height: 160px;

            .partner-title span {
              font-size: 13px;
            }
          }
        }
      }
    }

    // 动画基础类
    .animate-on-scroll {
      opacity: 0;
      transform: translateY(30px);
      transition: all 0.6s ease-out;

      &.show {
        opacity: 1;
        transform: translateY(0);
      }

      // 左侧滑入
      &.slide-left {
        transform: translateX(-30px);
        &.show {
          transform: translateX(0);
        }
      }

      // 右侧滑入
      &.slide-right {
        transform: translateX(30px);
        &.show {
          transform: translateX(0);
        }
      }
    }

    // 为企业文化卡片添加延迟
    .culture-grid {
      .culture-item {
        transition: transform 0.3s ease;

        &:hover {
          transform: translateY(-5px);
        }

        @for $i from 1 through 4 {
          &:nth-child(#{$i}) {
            transition-delay: #{$i * 0.1}s;
          }
        }
      }
    }

    // 合作伙伴动画
    .partners {
      .partner-item {
        transition: all 0.3s ease;

        &:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
        }
      }
    }

    // 联系我们动画
    .contact {
      .info-item {
        transition: all 0.3s ease;

        &:hover {
          transform: translateY(-3px);
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
        }
      }
    }
  }
}
</style> 